import script from "./EventsActivity.vue?vue&type=script&lang=ts&setup=true"
export * from "./EventsActivity.vue?vue&type=script&lang=ts&setup=true"

import "./EventsActivity.vue?vue&type=style&index=0&id=29eb2dfc&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29eb2dfc"]])

export default __exports__